import { useCallback, useEffect, useMemo, useState } from 'react';
import { CountryCodeConfig, CountryCode } from '@/data/countryCodes';

export type UseCountrySelectProps = {
  countryList: CountryCodeConfig[];
  value: CountryCode;
  onChange: (value?: CountryCode) => void;
};

/**
 * Hook for managing selected country code state
 */
export function useCountrySelect({ value, onChange, countryList }: UseCountrySelectProps) {
  const [selected, setSelected] = useState<CountryCode>(value);

  useEffect(() => {
    setSelected(value);
  }, [value]);

  const handleSelect = useCallback(
    (selectedCode: CountryCode) => {
      onChange(selectedCode);
      setSelected(selectedCode);
    },
    [onChange]
  );

  const selectedFlag = useMemo(
    () => countryList.find(({ code }) => code === selected)?.flag,
    [countryList, selected]
  );

  const selectedConfig = useMemo(
    () => countryList.find(({ code }) => code === selected),
    [countryList, selected]
  );

  return { selected, handleSelect, selectedFlag, selectedConfig };
}

